import { Location } from "vue-router";

import { ExerciseType, ExerciseViewData } from "@tt-app/models/exercise";
import { exerciseHandler, exerciseNavHandler } from "../common/handler";

export const getNewExerciseViewState = (
  exerciseType: ExerciseType,
  navFallback: Location
): ExerciseViewData => {
  return {
    exercise: exerciseHandler.getNewState(exerciseType),
    nav: exerciseNavHandler.getNewState(navFallback),
    loadingError: ""
  };
};
